export default "__VITE_ASSET__CF0xMsu3__"